import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isNonVectorImageUploadPopupShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { logoToUploadViewSelector, logoToUploadFileSelector } from '../../../redux/logo-editing/logo-editing.selectors';
import { isLimitedEditionSelector } from '../../../redux/product/product.selectors';
import { NonVectorImageUploadPopupComponent } from './non-vector-image-upload-popup';
const mapStateToProps = createStructuredSelector({
  open: isNonVectorImageUploadPopupShownSelector,
  view: logoToUploadViewSelector,
  file: logoToUploadFileSelector,
  isLimitedEdition: isLimitedEditionSelector
});
export const NonVectorImageUploadPopup = connect(mapStateToProps, null)(NonVectorImageUploadPopupComponent);